import { connect, ConnectedProps } from "react-redux"

import ErrorPage from "@components/ErrorPage"
import { AppState } from "@redux/reducer"
import { selectIsAuthenticated } from "@redux/reducer/auth"
import { SETTING_MARKETPLACE_FOR_LOGGED_IN_ONLY } from "config"

/**
 * A higher order component (HOC) to make sure a user is logged in when public pages should be hidden for non-logged-in users.
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function withAuthOnLoggedInOnlySetting<T>(Component: React.ComponentType<T>): React.FC<T> {
  const mapStateToProps = (state: AppState) => ({
    isAuthenticated: selectIsAuthenticated(state),
  })

  const connector = connect(mapStateToProps)
  type AuthProps = ConnectedProps<typeof connector>

  const WithAuthWrapper = (props: AuthProps) => {
    // @todo hack: remove all props that should not be passed on to the wrapped component, dispatch cannot be unused -> destructure again
    const { dispatch: { }, isAuthenticated, ...restProps } = props

    if (SETTING_MARKETPLACE_FOR_LOGGED_IN_ONLY && !isAuthenticated) {
      return <ErrorPage statusCode={403} error="failure.registeredUsersOnly" />
    }

    return <Component {...restProps as T} />
  }

  return connector(WithAuthWrapper)
}
